var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSnowflakes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 770 541",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", {
    id: "snowflake",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 2,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: -10,
    x2: 0,
    y2: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: -10,
    y1: 0,
    x2: 10,
    y2: 0
  }), /*#__PURE__*/React.createElement("line", {
    x1: -7,
    y1: -7,
    x2: 7,
    y2: 7
  }), /*#__PURE__*/React.createElement("line", {
    x1: -7,
    y1: 7,
    x2: 7,
    y2: -7
  }), /*#__PURE__*/React.createElement("line", {
    x1: -3,
    y1: -6,
    x2: -6,
    y2: -9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: -6,
    x2: 6,
    y2: -9
  }), /*#__PURE__*/React.createElement("line", {
    x1: -3,
    y1: 6,
    x2: -6,
    y2: 9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 6,
    x2: 6,
    y2: 9
  }), /*#__PURE__*/React.createElement("line", {
    x1: -6,
    y1: -3,
    x2: -9,
    y2: -6
  }), /*#__PURE__*/React.createElement("line", {
    x1: -6,
    y1: 3,
    x2: -9,
    y2: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: -3,
    x2: 9,
    y2: -6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 3,
    x2: 9,
    y2: 6
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.9)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#snowflake"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "17s",
    repeatCount: "indefinite",
    values: "80 -40; 120 560"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    additive: "sum",
    dur: "4s",
    repeatCount: "indefinite",
    values: "-6 0 0; 6 0 0; -6 0 0"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "17s",
    repeatCount: "indefinite",
    values: "0;1;1;0",
    keyTimes: "0;0.2;0.8;1"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.7)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#snowflake"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "22s",
    repeatCount: "indefinite",
    begin: "-5s",
    values: "260 -60; 230 560"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    additive: "sum",
    dur: "5s",
    repeatCount: "indefinite",
    values: "8 0 0; -8 0 0; 8 0 0"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "22s",
    repeatCount: "indefinite",
    values: "0;1;1;0",
    keyTimes: "0;0.15;0.85;1"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.1)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#snowflake"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "20s",
    repeatCount: "indefinite",
    begin: "-9s",
    values: "480 -50; 520 560"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    additive: "sum",
    dur: "6s",
    repeatCount: "indefinite",
    values: "-5 0 0; 5 0 0; -5 0 0"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "20s",
    repeatCount: "indefinite",
    values: "0;1;1;0",
    keyTimes: "0;0.2;0.8;1"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.6)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#snowflake"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "26s",
    repeatCount: "indefinite",
    begin: "-12s",
    values: "680 -70; 640 560"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    additive: "sum",
    dur: "5s",
    repeatCount: "indefinite",
    values: "-7 0 0; 7 0 0; -7 0 0"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "26s",
    repeatCount: "indefinite",
    values: "0;1;1;0",
    keyTimes: "0;0.2;0.8;1"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.3)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#snowflake"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "23s",
    repeatCount: "indefinite",
    begin: "-4s",
    values: "120 -80; 180 560"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    additive: "sum",
    dur: "7s",
    repeatCount: "indefinite",
    values: "4 0 0; -4 0 0; 4 0 0"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "23s",
    repeatCount: "indefinite",
    values: "0;1;1;0"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.85)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#snowflake"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "18s",
    repeatCount: "indefinite",
    begin: "-8s",
    values: "350 -40; 330 560"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    additive: "sum",
    dur: "6s",
    repeatCount: "indefinite",
    values: "6 0 0; -6 0 0; 6 0 0"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "18s",
    repeatCount: "indefinite",
    values: "0;1;1;0"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.0)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#snowflake"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "25s",
    repeatCount: "indefinite",
    begin: "-10s",
    values: "560 -60; 540 560"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    additive: "sum",
    dur: "7s",
    repeatCount: "indefinite",
    values: "-7 0 0; 7 0 0; -7 0 0"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "25s",
    repeatCount: "indefinite",
    values: "0;1;1;0"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.75)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#snowflake"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "21s",
    repeatCount: "indefinite",
    begin: "-6s",
    values: "40 -50; 90 560"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    additive: "sum",
    dur: "5s",
    repeatCount: "indefinite",
    values: "-5 0 0; 5 0 0; -5 0 0"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "21s",
    repeatCount: "indefinite",
    values: "0;1;1;0"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.55)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#snowflake"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "28s",
    repeatCount: "indefinite",
    begin: "-11s",
    values: "700 -90; 680 560"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    additive: "sum",
    dur: "6s",
    repeatCount: "indefinite",
    values: "4 0 0; -4 0 0; 4 0 0"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "28s",
    repeatCount: "indefinite",
    values: "0;1;1;0"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.4)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#snowflake"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "19s",
    repeatCount: "indefinite",
    begin: "-3s",
    values: "200 -40; 230 560"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    additive: "sum",
    dur: "4.5s",
    repeatCount: "indefinite",
    values: "-8 0 0; 8 0 0; -8 0 0"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "19s",
    repeatCount: "indefinite",
    values: "0;1;1;0"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 0
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.95)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#snowflake"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "24s",
    repeatCount: "indefinite",
    begin: "-7s",
    values: "100 -60; 140 560"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    additive: "sum",
    dur: "5.5s",
    repeatCount: "indefinite",
    values: "5 0 0; -5 0 0; 5 0 0"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "24s",
    repeatCount: "indefinite",
    values: "0;1;1;0"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    opacity: 0
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.65)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#snowflake"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "22s",
    repeatCount: "indefinite",
    begin: "-12s",
    values: "600 -70; 560 560"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    additive: "sum",
    dur: "6.2s",
    repeatCount: "indefinite",
    values: "-4 0 0; 4 0 0; -4 0 0"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "22s",
    repeatCount: "indefinite",
    values: "0;1;1;0"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    opacity: 0
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.8)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#snowflake"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "18s",
    repeatCount: "indefinite",
    begin: "-4s",
    values: "300 -40; 350 560"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    additive: "sum",
    dur: "4.2s",
    repeatCount: "indefinite",
    values: "6 0 0; -6 0 0; 6 0 0"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "18s",
    repeatCount: "indefinite",
    values: "0;1;1;0"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    opacity: 0
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.2)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#snowflake"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "27s",
    repeatCount: "indefinite",
    begin: "-9s",
    values: "420 -80; 460 560"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    additive: "sum",
    dur: "6.8s",
    repeatCount: "indefinite",
    values: "-6 0 0; 6 0 0; -6 0 0"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "27s",
    repeatCount: "indefinite",
    values: "0;1;1;0"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    opacity: 0
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.5)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#snowflake"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "30s",
    repeatCount: "indefinite",
    begin: "-13s",
    values: "720 -80; 690 560"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    additive: "sum",
    dur: "5s",
    repeatCount: "indefinite",
    values: "3 0 0; -3 0 0; 3 0 0"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "30s",
    repeatCount: "indefinite",
    values: "0;1;1;0"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    opacity: 0
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.0)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#snowflake"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "21s",
    repeatCount: "indefinite",
    begin: "-2s",
    values: "40 -50; 80 560"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    additive: "sum",
    dur: "6s",
    repeatCount: "indefinite",
    values: "4 0 0; -4 0 0; 4 0 0"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "21s",
    repeatCount: "indefinite",
    values: "0;1;1;0"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    opacity: 0
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.1)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#snowflake"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "19s",
    repeatCount: "indefinite",
    begin: "-6s",
    values: "280 -40; 310 560"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    additive: "sum",
    dur: "5.5s",
    repeatCount: "indefinite",
    values: "-6 0 0; 6 0 0; -6 0 0"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "19s",
    repeatCount: "indefinite",
    values: "0;1;1;0"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    opacity: 0
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.9)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#snowflake"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "23s",
    repeatCount: "indefinite",
    begin: "-11s",
    values: "180 -70; 200 560"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    additive: "sum",
    dur: "7s",
    repeatCount: "indefinite",
    values: "7 0 0; -7 0 0; 7 0 0"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "23s",
    repeatCount: "indefinite",
    values: "0;1;1;0"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    opacity: 0
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.65)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#snowflake"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "20s",
    repeatCount: "indefinite",
    begin: "-3s",
    values: "500 -40; 530 560"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    additive: "sum",
    dur: "4.5s",
    repeatCount: "indefinite",
    values: "-5 0 0; 5 0 0; -5 0 0"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "20s",
    repeatCount: "indefinite",
    values: "0;1;1;0"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    opacity: 0
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.35)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#snowflake"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "26s",
    repeatCount: "indefinite",
    begin: "-5s",
    values: "620 -80; 650 560"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    additive: "sum",
    dur: "7s",
    repeatCount: "indefinite",
    values: "5 0 0; -5 0 0; 5 0 0"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "26s",
    repeatCount: "indefinite",
    values: "0;1;1;0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnowflakes);
export default __webpack_public_path__ + "static/media/snowflakes.589bbb1e0604ba0b84ef0f8cb0cc2ec7.svg";
export { ForwardRef as ReactComponent };